import { router, routerFuns } from "sw-hic";
import { reportIndex } from "@sunway/masterdata";
// routerFuns.init({
//   patient: () => import("@/components/patient"),
//   deposit: () => import("@/components/deposit"),
//   bed: () => import("@/components/bed"),
//   settle: () => import("@/components/settle"),
// })

routerFuns.init(
  [
    {
      path: "/patient",
      name: "patient",
      component: () => import("@/components/patient"),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/patientInfo",
          name: "patientInfo",
          component: () => import("@/components/patient/card/overview"),
        },
        {
          path: "/patientDrug",
          name: "patientDrug",
          // component: () => import("@/components/patient/card/drug")
          component: () => import("@/components/drug/index"),
        },
        {
          path: "/patientEmr",
          name: "patientEmr",
          isComponent: true,
        },
        {
          path: "/patientAdvice",
          name: "patientAdvice",
          component: () => import("@/components/advice/index"),
        },
        {
          path: "/patientFee",
          name: "patientFee",
          component: () => import("@/components/fee/index"),
        },
        {
          path: "/patientVitalSign",
          name: "patientVitalSign",
          component: () => import("@/components/vitalSign/index"),
        },
        {
          path: "/patientExamine",
          name: "patientExamine",
          component: () => import("@/components/patient/card/examine"),
        },
      ],
    },
    {
      path: "/bed",
      name: "bed",
      component: () => import("@/components/bed"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/advice",
      name: "advice",
      component: () => import("@/components/advice"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/fee",
      name: "fee",
      component: () => import("@/components/fee"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/nursing",
      name: "nursing",
      component: () => import("@/components/nursing"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/drug",
      name: "drug",
      component: () => import("@/components/drug"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/vitalSign",
      name: "vitalSign",
      component: () => import("@/components/vitalSign"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report",
      name: "report",
      component: reportIndex,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/testPrint",
      name: "testPrint",
      component: () => import("@/components/test/print"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/testQuery",
      name: "testQuery",
      component: () => import("@/components/test/query"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/testReject",
      name: "testReject",
      component: () => import("@/components/test/reject"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/testCritical",
      name: "testCritical",
      component: () => import("@/components/test/critical"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/study",
      name: "study",
      component: () => import("@/components/study"),
      meta: {
        requiresAuth: true,
      },
    },
  ],
  [
    {
      path: "/drugPlacing",
      name: "drugPlacing",
      component: () => import("@/components/drugPlacing"),
      meta: {
        requiresAuth: true,
      },
    },
  ]
);

export default router;
